import { Combobox, ComboboxOption } from "~/components/ComboboxV2";
import {
    FILTER_OPERATOR_TO_ICON,
    FILTER_OPERATOR_TO_LABEL,
} from "~/modules/filters/consts";
import { FilterOperator } from "~/modules/filters/types";

// // // //

export function OperatorSelect(props: {
    value: FilterOperator;
    operators: FilterOperator[];
    onChange: (updatedValue: FilterOperator) => void;
}) {
    const { value, operators, onChange } = props;

    const options: ComboboxOption<FilterOperator>[] = operators.map((op) => ({
        value: op,
        label: FILTER_OPERATOR_TO_LABEL[op],
        icon_url: `/images/operator-icons/${FILTER_OPERATOR_TO_ICON[op]}`,
    }));

    return (
        <Combobox
            size="lg"
            itemSize="lg"
            value={value}
            onChange={(updatedValue) => {
                if (updatedValue) {
                    onChange(updatedValue);
                }
            }}
            options={options}
        />
    );
}
